import { FontWeightBold, FontSize300, ColorRed500, ColorBlue600 } from "@nxt-costco-com/forge-design-tokens";
const textStyles = {
  fontSize: FontSize300,
  fontWeight: FontWeightBold
};
const blueColorTextStyles = {
  color: ColorBlue600,
  ...textStyles
};
const redColorTextStyles = {
  color: ColorRed500,
  ...textStyles
};
const linkStyles = {
  flexGrow: 1,
  zIndex: 2
};
export {
  blueColorTextStyles,
  linkStyles,
  redColorTextStyles,
  textStyles
};
